module.exports = __webpack_public_path__ + "static/media/home-product-three.1b1ebdb7.png";